import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm, Popover,
} from 'antd';
import {
  DeleteOutlined, EditOutlined, EditTwoTone, HistoryOutlined, LoadingOutlined,
} from '@ant-design/icons';
import OfferActions from '@Actions/offerActions';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import OfferForm from '@Components/Common/Form/OfferForm';
import './style.scss';
import RecentTransactions from '@Components/Inventory/ManageProducts/ViewProduct/RecentTransactions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import ActivityLogActions from '@Actions/activityLogActions';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import ActivityLog from '../../../../Common/ActivityLog';

/**
 *
 */
class VendorPrices extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    this.state = {
      tableColumns: [
        {
          title: '',
          responsive: ['xs'],
          render: (text, record) => {
            const { history } = this.props;
            return (
              <div className="mobile-list__item">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <React.Fragment>
                    {' '}
                    <div
                      style={{
                        color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                      }}
                      onClick={() => history.push(`/vendors/view/${record?.seller_info?.seller_id}`)}
                    >
                      {record?.seller_info?.seller_name || ' - '}

                    </div>
                    <div>
                      {' '}
                      {record?.seller_info?.city || ' - '}
                    </div>
                  </React.Fragment>
                  <div style={{ display: 'flex' }}>
                    <div
                      className="roundIconButton"
                      onClick={() => {
                        this.setState({
                          addOfferModal: true,
                          selectedOffer: record,
                          isEditing: true,
                        });
                      }}
                    >
                      <EditOutlined />
                    </div>
                  </div>
                </div>

                <div>
                  {`Unit Price: ${record.offer_price}`}
                </div>
                <div>
                  {`MOQ: ${record.moq}`}
                </div>
                <div>
                  {`Packaging Details: ${record.packaging_details}`}
                </div>

              </div>
            );
          },
        },
        {
          title: 'VENDOR #',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => (
            <div>
              {' '}
              {record?.seller_info?.internal_slr_code || ' - '}
            </div>
          ),
        },
        {
          title: 'VENDOR',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => {
            const { history } = this.props;
            return (
              <React.Fragment>
                {' '}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
                >
                  <div
                    style={{
                      color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer', marginRight: '5px',
                    }}
                    onClick={() => history.push(`/vendors/view/${record?.seller_info?.seller_id}`)}
                  >
                    {record?.seller_info?.seller_name || ' - '}
                  </div>
                  {record?.is_default && (
                    <div className="status-tag">
                      Default
                    </div>
                  )}
                  &nbsp;
                  {record?.is_preferred_supplier && (
                    <div
                      className="status-tag"
                      style={{
                        backgroundColor: 'orange',
                      }}
                    >
                      Preferred
                    </div>
                  )}
                </div>
                <div>
                  {record?.seller_info?.city || ''}
                </div>
              </React.Fragment>

            );
          },
        },
        {
          title: 'UNIT PRICE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view unit price"} /> : this.props.MONEY(record.offer_price)),
        },
        {
          title: 'MOQ',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          dataIndex: 'moq',
        },
        {
          title: 'PACKAGING DETAILS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          dataIndex: 'packaging_details',
        },
        {
          title: '',
          dataIndex: '',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => {
            const {
              user, selectedProduct, archiveOfferPrice, archiveOfferPriceLoading, getOffers, selectedOffer, offers,
            } = this.props;
            return (
              <div className="list__actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <div
                  className="vendor_price-activity-log-button"
                  onClick={() => {
                    this.setState({
                      openOfferLog: true,
                      selectedOffer: record,
                      // isEditing: true,
                    });
                  }}
                >
                  <HistoryOutlined />
                </div>
                {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) && (
                  <div style={{
                    marginTop: '4px', marginRight: '5px', borderRadius: '4px', backgroundColor: 'rgba(45,124,247,0.05)', padding: '0px 5px',
                  }}
                  >
                    <RecentTransactions
                      tenantId={user?.tenant_info?.tenant_id}
                      sellerId={record?.seller_info?.seller_id}
                      productSkuId={selectedProduct?.product_sku_id}
                      internalSkuCode={selectedProduct?.internal_sku_code}
                      refProductCode={selectedProduct?.ref_product_code}
                      productSkuName={selectedProduct?.product_info?.product_sku_name}
                      sellerName={record?.seller_info?.seller_name}
                    />
                  </div>
                )}
                {
                  (isDataMaskingPolicyEnable && isHideCostPrice) ? (
                    <Popover
                      placement="topRight"
                      content="You don't have access to edit vendor price details"
                      title={(
                        <span>
                          <FontAwesomeIcon icon={faCircleExclamation} style={{ color: '#ff4d4f' }} />
                          {' '}
                          Restricted Access
                        </span>
                      )}
                    >
                      <div
                        className="vendor_price-delete-button"
                        style={{
                          marginTop: '4px',
                          marginRight: '5px',
                          borderRadius: '4px',
                          backgroundColor: 'rgba(45,124,247,0.05)',
                          padding: '0px 5px',
                          fontSize: '14px',
                          cursor: 'not-allowed',
                        }}
                      >
                        <EditTwoTone twoToneColor="#575757" />
                      </div>
                    </Popover>
                  ) : (
                    <React.Fragment>
                      { Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.UPDATE, user)
                      && (
                        <div
                          className="vendor_price-delete-button"
                          style={{
                            marginTop: '4px',
                            marginRight: '5px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(45,124,247,0.05)',
                            padding: '0px 5px',
                            fontSize: '14px',
                            color: 'rgb(45, 125, 247)',
                          }}
                          onClick={() => {
                            this.setState({
                              addOfferModal: true,
                              selectedOffer: record,
                              isEditing: true,
                            });
                          }}
                        >
                          <EditOutlined />
                        </div>
                      )}
                    </React.Fragment>
                  )
                }
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.DELETE, user) && (
                  <Popconfirm
                    placement="topRight"
                    disabled={archiveOfferPriceLoading}
                    title="Are you sure you want to delete this Price?"
                    onConfirm={() => {
                      this.setState({
                        selectedOffer: record,
                      });
                      const payload = {
                        sku_offer_id: record.sku_offer_id,
                      };
                      archiveOfferPrice(payload, () => {
                        getOffers(selectedProduct?.tenant_product_id, '');
                      });
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div className="vendor_price-delete-button">
                      <DeleteOutlined />
                    </div>
                  </Popconfirm>
                )}
              </div>
            );
          },
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getOffers, selectedProduct, getActivityLogSuccess } = this.props;
    getActivityLogSuccess(null);
    getOffers(selectedProduct?.tenant_product_id, '');
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      getOffersLoading, offers, selectedProduct, getOffers, user, archiveOfferPriceLoading, priceMasking,
    } = this.props;
    const {
      tableColumns, addOfferModal, selectedOffer, isEditing, openOfferLog,
    } = this.state;

    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    return (
      <Fragment>
        <Drawer
          open={addOfferModal}
          destroyOnClose
          footer={null}
          width="360px"
          onClose={
            () => this.setState({
              addOfferModal: false,
            })
          }
        >
          <OfferForm
            marketplace={selectedProduct?.is_marketplace_product}
            currentLine={selectedProduct}
            selectedOffer={selectedOffer}
            callback={() => {
              this.setState({
                addOfferModal: false,

              });
              getOffers(selectedProduct?.tenant_product_id, '');
            }}
            isEditing={isEditing}
            toggleNewOfferModal={() => this.setState({ addOfferModal: false })}
          />
        </Drawer>
        <Drawer
          open={openOfferLog}
          destroyOnClose
          footer={null}
          width="360px"
          onClose={
            () => this.setState({
              openOfferLog: null,
            })
          }>
            <ActivityLog
              entityId={selectedOffer?.sku_offer_id}
              entityType="sku_offer"
              entityName="SKU Offer"
            />
        </Drawer>
        <div className="generic-table-container">
          <Table
            loading={getOffersLoading || archiveOfferPriceLoading}
            showHeader
            size="small"
            scroll="scroll"
            tableLayout="unset"
            top="none"
            bottom="bottomRight"
            columns={tableColumns}
            dataSource={offers ? offers.offers : []}
            title={() => (
              <div className="product-offer__table-header">
                {`${(offers && offers.count) ? offers.count : '0'} Vendor Price(s) Available`}
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.CREATE, user) && (
                  <div className="product-offer__table-header__left">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Vendor Price"
                      onClick={() => this.setState({ addOfferModal: true, isEditing: false, selectedOffer: null })}
                      customClass="product-offer__add-button"
                      disabled={isDataMaskingPolicyEnable && isHideCostPrice}
                    />
                  </div>
                )}
              </div>
            )}
            pagination={offers?.count > 10}
            rowClassName={(record) => (!record.is_active ? 'inactive_record' : '')}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, OfferReducers, ProductReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  selectedProduct: ProductReducers.selectedProduct,
  archiveOfferPriceLoading: OfferReducers.archiveOfferPriceLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  archiveOfferPrice: (payload, callback) => dispatch(OfferActions.archiveOfferPrice(payload, callback)),
  getActivityLogSuccess: (activityLog) => dispatch(ActivityLogActions.getActivityLogSuccess(activityLog)),

});

VendorPrices.propTypes = {
  user: PropTypes.any,
  selectedProduct: PropTypes.any,
  getOffers: PropTypes.func,
  offers: PropTypes.any,
  getOffersLoading: PropTypes.bool,
  history: PropTypes.func,
  MONEY: PropTypes.func,
  archiveOfferPrice: PropTypes.func,
  archiveOfferPriceLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorPrices));
